export default __webpack_public_path__ + "static/5-7c84f609e60629ca95c9a72e36745f00.png";